import { axiosGet } from '../../axios/axios.js'

export const requestRoadsObjectsSearch = {
  methods: {
    getSources: function () {
      return axiosGet({
        url: '/service/delta/roadsRequest/ref/getSources',
        onSuccess: (response) => response.data.result,
        onFailure: 'Ошибка получения источников'
      })
    },
    getServiceObjectTypes: function (requestId) {
      let url = '/service/delta/roadsRequest/ref/getRefData'
      if (requestId) {
        url += '?requestId=' + requestId
      }
      return axiosGet({
        url: url,
        onSuccess: (response) => {
          return response.data.result
        },
        onFailure: 'Ошибка получения типов объекта'
      })
    },
    getServiceObjects: function () {
      return axiosGet({
        url: '/service/delta/roadsRequest/ref/getServiceObjects?typeId=' + this.roadsRequestCommand.serviceObjectType.id,
        onSuccess: (response) => response.data.result,
        onFailure: 'Ошибка получения объектов'
      })
    },
    getDescriptionTypes: function () {
      return this.roadsRequestCommand.serviceObjectType && this.roadsRequestCommand.serviceObjectType.descriptions || []
    },
    getRequestTypesVis: function () {
      return this.roadsRequestCommand.serviceObjectType && this.roadsRequestCommand.serviceObjectType.requestTypeVis || []
    },
    getEquipmentRoadsStatuses: function () {
      return this.roadsRequestCommand.requestTypeVis && this.roadsRequestCommand.requestTypeVis.equipmentRoadsStatus || []
    },
    getCloseEquipmentRoadsStatuses: function () {
      return axiosGet({
        url: '/service/delta/roadsRequest/ref/getEquipmentRoadsStatuses',
        onSuccess: (response) => response.data.result,
        onFailure: 'Ошибка получения состояний оборудования'
      })
    },
    getBreakageRoadsTypes: function () {
      return this.roadsRequestCommand.serviceObjectType && this.roadsRequestCommand.serviceObjectType.breakages || []
    },
    getDefaultClosingCommentsRoads: function (typeId) {
      let url = '/service/delta/roadsRequest/ref/getDefaultClosingCommentsRoads'
      if (typeId != null) {
        url += '?typeId=' + typeId
      }
      return axiosGet({
        url: url,
        onSuccess: (response) => response.data.result,
        onFailure: 'Ошибка получения типовых комментариев по выполненным работам'
      })
    },
    getRoadsDepartments: function () {
      return axiosGet({
        url: '/service/delta/roadsRequest/ref/getSubdivisions',
        onSuccess: (response) => response.data.result,
        onFailure: 'Ошибка получения подразделений'
      })
    },
    getPriorities: function () {
      return axiosGet({
        url: '/service/delta/roadsRequest/ref/getPriorities',
        onSuccess: (response) => response.data.result,
        onFailure: 'Ошибка получения приоритетов'
      })
    },
    getEditors: function () {
      return axiosGet({
        url: '/service/delta/roadsRequest/ref/getRoadsEditors',
        onSuccess: (response) => response.data.result,
        onFailure: 'Ошибка получения редакторов'
      })
    },
    getTags: function () {
      return axiosGet({
        url: '/service/delta/roadsRequest/ref/getTags',
        onSuccess: (response) => response.data.result.map(tagName => {
          return {
            id: tagName,
            name: tagName
          }
        }),
        onFailure: 'Ошибка получения значений тэгов'
      })
    }
  }
}
